export default __webpack_public_path__ + "static/media/jquery-logo.55de1cbe.svg";